angular.module('impactx.deliverynote').controller('DeliveryNoteTotalCtrl', [
    '$scope',
    '$mdDialog',
    'data',
    'themeFactory',
    'trns',
    'dataGen',
    '$route',
    'ToastService',
    'TranslationService',
    'count',
    'sum',
    'withSerialNumber',
    DeliveryNoteTotalCtrl]);

function DeliveryNoteTotalCtrl($scope, $mdDialog, data, themeFactory, trns, dataGen, $route, ToastService, TranslationService, count, sum, withSerialNumber)
{
    var self = this;
    $scope.data = data;
    $scope.trns = trns;
    $scope.count = count;
    $scope.sum = sum;
    $scope.abortLabel = TranslationService.get("abort");
    $scope.saveLabel = $scope.trns.grnTotal;
    $scope.theme = themeFactory.getTheme();

    $scope.withSerialNumber = !!withSerialNumber;
    // Current DNI
    $scope.editDniIndex = -1;
    // List of the current edited serial number of each DNI
    $scope.editIndexes = Array($scope.data.dnh.deliveryNoteItems.length).fill(0);

    this.cancel = function ()
    {
        $mdDialog.cancel();
    };

    this.answer = function ()
    {
        $scope.data.dnh.acceptPartialDelivery = true;
        $scope.data.dnh.acceptOverShipment = true;
        $scope.data.dnh.acceptOthers = true;

        var dataObj = {
            data: $scope.data,
            fromReadOnly: false,
            grnTotal: true
        };
        dataGen.post($scope, dataObj, "/deliverynote/saveAndClose").then(function () {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            $mdDialog.hide();
            $route.reload();
        });
    };

    // Serial Number Methods
    this.setEditIndex = function (pIndex, index) {
        $scope.editDniIndex = pIndex;
        $scope.editIndexes[pIndex] = index;
    };

    function hasChosenItem() {
        return $scope.editDniIndex >= 0 && $scope.editDniIndex < $scope.data.dnh.deliveryNoteItems.length;
    }

    this.showForwardButton = function () {
        return hasChosenItem() && $scope.editIndexes[$scope.editDniIndex] + 1 < parseInt($scope.data.dnh.deliveryNoteItems[$scope.editDniIndex].deliveredAmount.value)
    };

    this.disableForwardButton = function () {
        return !(hasChosenItem() && $scope.data.dnh.deliveryNoteItems[$scope.editDniIndex].dniInfoItems[$scope.editIndexes[$scope.editDniIndex]] &&
            $scope.data.dnh.deliveryNoteItems[$scope.editDniIndex].dniInfoItems[$scope.editIndexes[$scope.editDniIndex]].value)
    }

    this.forward = function () {
        if (self.showForwardButton() && !self.disableForwardButton())
        {
            if ($scope.editIndexes[$scope.editDniIndex] + 1 >= $scope.data.dnh.deliveryNoteItems[$scope.editDniIndex].dniInfoItems.length) {
                $scope.data.dnh.deliveryNoteItems[$scope.editDniIndex].dniInfoItems.push({value: ""});
            }
            const elem = document.getElementById("serialNumber" + $scope.editDniIndex);
            if(elem && document.activeElement !== elem) {
                setTimeout(function () {
                    elem.focus();
                });
            }
            $scope.editIndexes[$scope.editDniIndex]++;
        }
    };

    this.showForwardButtonItem = function () {
        return $scope.editDniIndex >= 0 && $scope.editDniIndex + 1 < $scope.data.dnh.deliveryNoteItems.length;
    };

    this.forwardItem = function () {
        if (self.showForwardButtonItem())
        {
            const nextpIndex = $scope.editDniIndex + 1;
            setTimeout(function () {
                document.getElementById("serialNumber" + nextpIndex).focus();
                document.getElementById("serialNumber" + nextpIndex).scrollIntoView({block: "center"});
            });
            self.setEditIndex(nextpIndex, 0);
        }
    };

    this.canDeleteAll = function () {
        return $scope.data.dnh.deliveryNoteItems && $scope.data.dnh.deliveryNoteItems.some(function (item) {
            return item.dniInfoItems.length > 0;
        });
    };

    this.deleteAll = function () {
        $scope.editIndexes = Array($scope.data.dnh.deliveryNoteItems.length).fill(0);
        $scope.data.dnh.deliveryNoteItems.map(function(item) {
            item.dniInfoItems = [];
        });
        $scope.editDniIndex = -1;
    };

    this.setFocusItem = function (pIndex) {
        if($scope.editDniIndex !== pIndex)
        {
            $scope.editDniIndex = pIndex;
        }
    };

    // End Serial Number Methods
}